import React from "react";
import { Box } from "@mui/material";
import moment from "moment";
import styles from "./ActivityList.module.css";
import stageDot from "../../assets/images/stage-dot.svg";
import nameLine from "../../assets/images/name-line.svg";
import getTeamMember, {
  getDescriptionWithMentionedNames,
} from "../CommonFunctions/CommonFunctions";

function ActivityComment(props: any) {
  const { data, employees } = props;

  const modifiedDescription = getDescriptionWithMentionedNames(
    data?.activityData?.description,
    employees
  ).replace(/\n/g, "<br>");

  return (
    <>
      <Box
        sx={{
          width: "100%",
          margin: "0 15px 22px 15px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className={styles.activityHead}>
            <div className={styles.activityTop}>
              <div className={styles.activityDateStyle}>
                {moment(data?.creationDate).format("DD MMM YYYY, hh:mm A")}
              </div>
              <div className={styles.activityHeadStage}>
                <div className={styles.activityHeadStageIcon}>
                  <img src={stageDot} alt="" />
                </div>
                <div>{data?.currentStage}</div>
              </div>
              <div className={styles.activityHeadName}>
                <div className={styles.activityHeadStageIcon}>
                  <img src={nameLine} alt="" />
                </div>
                <div style={{ textTransform: "capitalize" }}>
                  {data.activityType === "COMMENT_ADDED_TO_TASK"
                    ? getTeamMember(data?.createdById, employees)?.firstName +
                    " " +
                    getTeamMember(data?.createdById, employees)?.lastName
                    : getTeamMember(data?.updatedById, employees)?.firstName +
                    " " +
                    getTeamMember(data?.updatedById, employees)?.lastName}
                </div>
              </div>
            </div>
          </div>

          <div
            className={styles.activityDemoTitle}
            style={{
              color:
                data.activityType === "COMMENT_DELETED_FROM_TASK"
                  ? "#EC3939"
                  : "#142C44",
            }}
          >
            {data.activityType === "COMMENT_ADDED_TO_TASK"
              ? "Comment Added to Task"
              : data.activityType === "COMMENT_EDITED_ON_TASK"
                ? "Comment Edited on Task"
                : data.activityType === "COMMENT_DELETED_FROM_TASK"
                  ? "Comment Deleted from Task"
                  : ""}
          </div>
          <div
            className={styles.activityDescription}
            dangerouslySetInnerHTML={{ __html: modifiedDescription }}
          />
        </Box>
      </Box>
    </>
  );
}

export default ActivityComment;
